/* fizzy-mission-comparison-gallery
   - Drag the handle on each before/after slider to wipe between panes.
   - Click a topic thumbnail to swap the active image + detail panel. */
(function () {
  function initCompare(compare) {
    if (compare.dataset.fmcgReady) return;
    compare.dataset.fmcgReady = '1';

    var handle = compare.querySelector('.fmcg-compare__handle');
    var dragging = false;

    function setPercent(clientX) {
      var rect = compare.getBoundingClientRect();
      var pct = ((clientX - rect.left) / rect.width) * 100;
      pct = Math.max(0, Math.min(100, pct));
      compare.style.setProperty('--percent', pct + '%');
    }

    function start(e) {
      dragging = true;
      compare.classList.add('is-dragging');
      var x = e.touches ? e.touches[0].clientX : e.clientX;
      setPercent(x);
    }
    function move(e) {
      if (!dragging) return;
      var x = e.touches ? e.touches[0].clientX : e.clientX;
      setPercent(x);
    }
    function end() {
      dragging = false;
      compare.classList.remove('is-dragging');
    }

    compare.addEventListener('mousedown', start);
    window.addEventListener('mousemove', move);
    window.addEventListener('mouseup', end);
    compare.addEventListener('touchstart', start, { passive: true });
    compare.addEventListener('touchmove', move, { passive: true });
    compare.addEventListener('touchend', end);

    if (handle) {
      handle.addEventListener('keydown', function (e) {
        var cur = parseFloat(getComputedStyle(compare).getPropertyValue('--percent')) || 50;
        if (e.key === 'ArrowLeft') { compare.style.setProperty('--percent', Math.max(0, cur - 4) + '%'); e.preventDefault(); }
        if (e.key === 'ArrowRight') { compare.style.setProperty('--percent', Math.min(100, cur + 4) + '%'); e.preventDefault(); }
      });
    }
  }

  function initGallery(root) {
    if (root.dataset.fmcgInit) return;
    root.dataset.fmcgInit = '1';

    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.fmcg__thumb'));
    var images = Array.prototype.slice.call(root.querySelectorAll('.fmcg__image'));
    var infos = Array.prototype.slice.call(root.querySelectorAll('.fmcg__info'));

    function activate(index) {
      [thumbs, images, infos].forEach(function (group) {
        group.forEach(function (el) {
          el.setAttribute('aria-current', String(Number(el.dataset.index) === index));
        });
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        activate(Number(thumb.dataset.index));
      });
    });

    root.querySelectorAll('.fmcg-compare').forEach(initCompare);
  }

  function boot() {
    document.querySelectorAll('.fmcg').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', boot);
})();
